import styled from "styled-components";
import {getLineHeight, parseSize} from "../../../common/generic-react.functions.js";
export const ButtonContainer = styled.button.attrs(({
  disabled
}) => ({
  disabled
})).withConfig({
  displayName: "buttonstyles__ButtonContainer",
  componentId: "sc-1am45dn-0"
})(["", " font-size:", ";line-height:", ";", " ", " ", " ", " ", " ", " ", ""], {
  display: "inline-flex",
  justifyContent: "center",
  verticalAlign: "middle",
  alignItems: "center",
  paddingTop: "0.5rem",
  paddingBottom: "0.5rem",
  paddingLeft: "2rem",
  paddingRight: "2rem",
  borderStyle: "none",
  userSelect: "none"
}, ({
  size
}) => parseSize(size), ({
  size
}) => getLineHeight(size), ({
  block
}) => block && {
  width: "100%"
}, ({
  color,
  text
}) => color && !text && `background-color: ${color};`, ({
  textColor
}) => textColor && `color: ${textColor};`, ({
  disabled
}) => disabled ? {
  cursor: "not-allowed"
} : {
  cursor: "pointer"
}, ({
  rounded
}) => rounded && {
  borderRadius: "0.25rem"
}, ({
  text,
  icon
}) => (text || icon) && {
  backgroundColor: "rgba(0, 0, 0, 0)"
}, ({
  icon
}) => icon && {
  borderRadius: "9999px"
});
